export default __webpack_public_path__ + "assets/images/No-Negative-f0482aa3401ee966bc33d7242f718786.svg";